import { hasMany } from '@warp-drive/legacy/model';
import DigitalAsset from './digital-asset.ts';
import type AccountTransactionModel from './account-transaction.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class MatchAssetModel extends DigitalAsset {
  /*************************
   **  Relationships      **
   *************************/

  @hasMany('account-transaction', { async: false, inverse: 'matchAssets' })
  declare accountTransactions: AccountTransactionModel[];

  [Type] = 'match-asset' as const;
}
